var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{staticClass:"labeled-select",class:_vm.cssClass,attrs:{"label":_vm.label,"id":_vm.id}},[_c('blumar-multiselect',_vm._g(_vm._b({attrs:{"label":_vm.textField || 'name',"trackBy":_vm.idField || 'id',"id":_vm.selectId,"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}},'blumar-multiselect',_vm.$props,false),_vm.$listeners),[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ffbb2c1c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/LabeledSelect.vue
// module id = 1069
// module chunks = 0